<template>
    <div element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loading="loading">
            <el-page-header style="margin-bottom: 20px" @back="goBack"></el-page-header>
            <div v-for="(item,index) in classlist" :key="index">{{ item.gradeName+item.className }}</div>
            <el-tabs v-model="activeName" v-for="(item,index) in classlist" :key="index">
                <el-tab-pane :label="item.gradeName+item.className" :name="item.classId"></el-tab-pane>
            </el-tabs>
            <el-table key="detailDataTable" :data="detailDataTable" stripe border style="width: 100%; margin-top: 15px">
                <el-table-column type="index" label="序号" align="center"> </el-table-column>
                <el-table-column prop="studentName" label="学生姓名" align="center"> </el-table-column>
                <el-table-column prop="readCount" label="在读" align="center"></el-table-column>
                <el-table-column prop="readingNumber" label="已读" align="center"></el-table-column>
                <el-table-column prop="homeworkCount" label="作业" align="center"></el-table-column>
                <el-table-column prop="startTime" label="阅读开始时间" align="center">
                    <template slot-scope="scope">
                        {{scope.row.startTime?scope.row.startTime:'--'}}
                    </template>
                </el-table-column>
                <el-table-column prop="endTime" label="阅读完成时间" align="center"> 
                    <template slot-scope="scope">
                        {{scope.row.endTime?scope.row.endTime:'--'}}
                    </template>
                </el-table-column>
                <el-table-column prop="starValue" label="获得星星值" align="center"> </el-table-column>
            </el-table>
    </div>
</template>

<script>
import {
    queryStudentList,
} from '@/api/home'
export default {
    data() {
        return {
            studentId: '',
            activeName: '',
            options: [],
            value: '',
            value1: '',
            gradeList: [],
            classList: [],
            gradeId: '',
            classId: '',
            loading: false,
            schoolId: '',
            gradeTable: [],
            classTable: [],
            studentTable: [],
            detailData: {},
            init: true,
            page: 1,
            taskType: '',
            list:{},
            readStatus: '',
            typeList: [],
            statusList: [],
            detailDataTable: [],
            detailDataTotal: 0,
            queryTime: [],
            queryTime1: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            }
        }
    },
    watch: {
        activeName(){
            this.queryStudentList()
        }
    },
    methods: {
        goBack() {
            history.go(-1);
        },
        queryStudentList() {
            let that = this
            that.loading = true
            let params = {
                // termId: this.value1,
                taskId: this.list.id,
                classId: this.classId,
                pageNum: this.page,
                pageSize: 1000,
            }
            queryStudentList(params)
                .then((res) => {
                    that.loading = false
                    that.detailDataTable = res.data.data.dataList
                    that.detailDataTotal = res.data.data.totalCount
                })
                .catch(() => {
                    that.loading = false
                })
        },
    },
    created() {
        this.list=JSON.parse(this.$route.query.list)
        this.classList=[]
        this.classList=JSON.parse(this.$route.query.list).readTaskScopeList
        this.classId=this.classList[0].classId
        this.queryStudentList()
    },
    mounted() {
        
        this.schoolId = JSON.parse(localStorage.getItem('info')).schoolId
    }
}
</script>

<style scoped>
.chartTitle {
    padding: 10px 20px;
    background: #f0f0f0;
    color: red;
    margin: 10px 0;
}

.detailChartBox {
    padding: 15px;
    height: 120px;
    background: #eaf1fb;
    display: flex;
}

.chartBoxText {
    font-size: 15px;
    margin: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/readTask/details.vue